import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CustomObjectData} from "./custom-object.data";

@Injectable()
export class CustomObjectEntityModel extends EntityModel<CustomObjectData> {
    constructor(injector: Injector) {
        super(injector, CustomObjectData);
    }

    override getResourceName(): string {
        return "custom-object";
    }

    override getResource(): string {
        return "custom-group";
    }
}
